/*
 * Copyright (c) Nexign, JSC, 2021.
 */

/**
 * GTM operations for widget useful links
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { IGTMOperation } from './index';

export const clickLinkWidgetUsefulLinks = (linkName: string): IGTMOperation => ({
    'event': 'addEvents_useNavigations',
    'event_id': 'd-v402-e2',
    'event_cat': 'Популярные операции',
    'event_name': 'clickLink',
    'event_param': linkName,
});
